import React, { useState, useEffect } from 'react';
import { Modal, Container, Row, Col, Button, Table } from 'react-bootstrap';
import axios from "axios";
import Swal from "sweetalert2";
import './OrderDetail.css';
import { Link } from 'react-router-dom';

import { MdDelete } from "react-icons/md";

const OrderDetail = ({ order, user }) => {
  const cartItems = order?.cart || [];
  const apiURL = process.env.REACT_APP_API_URL;

  // ✅ Inicializa con el estado real de la orden
  const [status, setStatus] = useState(order?.status || "");

  // ✅ Si order llega async / cambia, sincroniza el select
  useEffect(() => {
    setStatus(order?.status || "");
  }, [order?.status]);

  const iconStyle = { cursor: 'pointer' };

  const deleteTicket = async (id) => {
    try {
      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Esta acción no se puede deshacer',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });

      if (!result.isConfirmed) return;

      await axios.delete(`${apiURL}/api/purchase/${id}/${user.uid}`);

      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Orden Eliminada',
        showConfirmButton: false,
        timer: 1500,
      });

    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "No se pudo eliminar la orden",
      });
    }
  };

  const uptadeOder = async (code) => {
    try {
      // ✅ Evita mandar update si no hay status seleccionado
      if (!status) {
        return Swal.fire({
          icon: "warning",
          title: "Atención",
          text: "Selecciona un estado válido antes de actualizar.",
        });
      }

      const changes = { status };

      await axios.put(`${apiURL}/api/purchase/${code}/${user.uid}`, changes);

      await Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Orden Actualizada',
        showConfirmButton: false,
        timer: 1500,
      });

      // ❌ No resetear status a undefined
      // setStatus(); // <- eliminado

    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || error?.message || "No se pudo actualizar la orden",
      });
    }
  };

  return (
    <Container>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Nombre</th>
            <th>Documento</th>
            <th>Email</th>
            <th>Celular</th>
            <th>Mensaje</th>
            <th>Total pedido</th>
            <th>Estado de la orden</th>
            <th>Estado de la transacción</th>
            <th>Eliminar orden</th>
          </tr>
        </thead>

        <tbody>
          <tr key={order?._id || order?.id}>
            <td>{order?.purchase_datetime}</td>
            <td>{order?.name}</td>
            <td>{order?.identification_document}</td>
            <td>{order?.purchaser}</td>
            <td>{order?.phone}</td>
            <td>{order?.message}</td>
            <td>${order?.amount}</td>

            <td>
              <select
                value={status || ""}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="pendiente">Pendiente</option>
                <option value="en_proceso">En proceso</option>
                <option value="finalizada">Finalizada</option>
              </select>

              <Button
                variant="success"
                onClick={() => uptadeOder(order?.code)}
                style={{ marginLeft: 8 }}
                disabled={!order?.code}
              >
                Actualizar Estado
              </Button>
            </td>

            <td>{order?.statusPay}</td>

            <td>
              <Link to='/orders'>
                <MdDelete
                  style={iconStyle}
                  onClick={() => deleteTicket(order?._id)}
                />
              </Link>
            </td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Departamento</th>
            <th>Ciudad o Municipio o Localidad</th>
            <th>Barrio</th>
            <th>Dirección</th>
            <th>Referencias del lugar de entrega</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{order?.departamento}</td>
            <td>{order?.ciudad_o_municipio}</td>
            <td>{order?.barrio}</td>
            <td>{order?.direccion}</td>
            <td>{order?.referencias_entrega}</td>
          </tr>
        </tbody>
      </Table>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Titulo</th>
            <th>Código</th>
            <th>Foto</th>
            <th>Cant</th>
            <th>Precio.U</th>
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          {cartItems.map((prod) => (
            <tr key={prod.id || prod.code}>
              <td>{prod.title}</td>
              <td>{prod.code}</td>
              <td>
                <img
                  src={prod.image}
                  alt={prod.title}
                  className="imagen-miniatura"
                />
              </td>
              <td>{prod.quantity}</td>
              <td>${prod.price}</td>
              <td>${prod.price * prod.quantity}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default OrderDetail;
